import {useSelector} from "react-redux";
import {getActiveBrandId} from "@Libraries/brands-library.js";

/**
 *
 * @return {string | null}
 */
export const useActiveBrandId = () => {
    return useSelector(({brands}) => getActiveBrandId(brands));
}
